<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
<folder-view-sidebar :isSidebarActive="addNewFolderSidebar" @getdata="getdata" @closeSidebar="toggleFolderSidebar" :data="folderSidebarData" />
<!-- <vs-breadcrumb
:items="bredcrums"
></vs-breadcrumb> -->

<vs-row vs-w="12">
  <vs-col  vs-justify="flex-start" vs-align="center" vs-w="7">
    <span class="flex" v-if="activebredcrum">
    <h1 class="inline-flex">{{activebredcrum}}</h1>
    <feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning']" class="cursor-pointer ml-2 inline-flex"  />
    </span>
    <vs-breadcrumb>
   <li v-if="activebredcrum">
     <router-link to="/images">Folders</router-link><span class="vs-breadcrum--separator">/</span></li>
   <li>
   <li v-for="bred in bredcrums" :key="bred.id">
     <router-link  :to="{ path: '/folder' +'/'+ bred.id}">{{bred.name}}</router-link><span class="vs-breadcrum--separator">/</span>
   </li>
   <li aria-current="page" class="active">{{activebredcrum}}</li>
</vs-breadcrumb>
  </vs-col>
  <vs-col  vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5">
    <div class="flex justify-end mb-base">
<input type="file" class="hidden" multiple ref="uploadImageInput" @change="uploadNewImage" accept="image/*">
<vs-button class="mr-4" size="small" icon-pack="feather" icon="icon-upload" @click.native="$refs.uploadImageInput.click()">Upload</vs-button>
<vs-button class="mr-4"  size="small" icon-pack="feather" icon="icon-plus"   @click.native="addNewFolder($route.params.folder)">Create Folder</vs-button>
<vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="search" class="is-label-placeholder mt-0 mb-0" />
</div>
  </vs-col>
</vs-row>

<div class="items-grid-view vx-row match-height" v-if="currentItemView == 'item-grid-view'" >
<!-- <div class="vx-col lg:w-1/12 sm:w-1/6 xs-w-1/3 w-full" v-for="folder in folders" :key="folder.id" > -->
<vs-col class="vx-col lg:w-1/12" vs-lg="1" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="2"  vs-xs="3" v-for="folder in allFolders" :key="folder.id">
<folder-grid-view @getdata="getdata" :item="folder" ></folder-grid-view>
</vs-col>
<!-- </div>   -->
</div>
<div class="flex justify-between">
<div>
<small class="cursor-pointer hover:text-primary" @click="SelectALL()" v-if="SelectedItem.length==0" >Select All</small>
<small class="cursor-pointer hover:text-primary" @click="UnSelectALL()" v-if="SelectedItem.length > 0">Unselect All</small>  
<vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-5 ml-5" v-if="SelectedItem.length > 0">
<div class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
<span class="mr-2">Actions ({{SelectedItem.length}})</span>
</div>
<vs-dropdown-menu>
<vs-dropdown-item @click="deleteImgAction()">
<span class="flex items-center" >
<feather-icon icon="TrashIcon"  svgClasses="h-4 w-4" class="mr-2" />
<span>Delete</span>
</span>
</vs-dropdown-item>
<vs-dropdown-item @click="ResizePopup=true">
<span class="flex items-center" >
<feather-icon icon="MaximizeIcon"  svgClasses="h-4 w-4" class="mr-2" />
<span>Resize</span>
</span>
</vs-dropdown-item>
</vs-dropdown-menu>
</vs-dropdown>
</div>
<div class="flex justify-end mb-5">
    <h6>Sort By :</h6> 
    <small class="ml-1" >Name
    <span @click="sortByName('desc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon v-if="sortNameIcon" icon="ChevronUpIcon" svgClasses="h-4 w-4"  />
    </span>
    <span @click="sortByName('asc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon  v-if="!sortNameIcon" icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
     </span>
    </small>

    <small class="ml-2">Upload
    <span @click="sortByTime('desc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon v-if="sortTimeIcon" icon="ChevronUpIcon" svgClasses="h-4 w-4"/>
    </span>
    <span @click="sortByTime('asc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon v-if="!sortTimeIcon" icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
    </span>
    </small>
</div>
</div>
<div class="items-grid-view vx-row match-height" v-if="currentItemView == 'item-grid-view'" v-viewer> 

<vs-col :id="'div-with-'+item.id" class="vx-col lg:w-1/6 vs-con-loading__container" vs-lg="2" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="3"  vs-xs="6" v-for="item in allImages" :key="item.id" >
<item-grid-view @selectItem="selectItem" @getdata="getdata" :item="item"></item-grid-view>

</vs-col>
</div>
<template slot="no-body">
<vs-popup title=" " :active.sync="ResizePopup">
    <vs-row >
        <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10" style="border:2px solid black;background:black">
            <img :src="currentImg.url" alt="" style="height:500px">
            <img :src="resizeImg" alt="">
        </vs-col> -->
        <vs-col vs-type="flex" vs-justify="center"   vs-w="12">
         <vx-card  title="Resize Image" title-color="primary" subtitle="Enter Width (px) eg. 200">
           <vs-input v-model="imgWidth"></vs-input>
           <vs-button size="small" @click.native="resizeAction(imgWidth,SelectedItem)" :disabled="setDisable" class="mt-2">Set</vs-button>
         </vx-card>
        </vs-col>
    </vs-row>
</vs-popup>
            
</template>
</div>    
</template>

<script>
import FolderViewSidebar from './FolderViewSidebar.vue'
import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  Vue.use(Viewer)
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  dirName: 'ImageLibrary',
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)
import {
ADD_IMAGE_TO_LIBRARY,
GET_FOLDER_IMAGE,
BULK_DELETE_IMAGES,
GET_FOLDER_SUBFOLDER,
GET_DIRECTORY_BREDCRUM
} from '@/graphql'
export default {
  components: {
    ItemGridView: () => import('./components/ItemGridView.vue'),
    FolderGridView: () => import('./components/FolderGridView.vue'),
        FolderViewSidebar,

  },
  data () {
    return {
      activeTab:0,
      currentItemView: 'item-grid-view',
      addNewFolderSidebar: false,
      folderSidebarData : null,
      orignal_images:[],
      orignal_folders:[],
      images:[],
      folders:[],
      directroy:[],
      sortNameIcon:false,
      sortTimeIcon:true,
      activeLoading:false,
      SelectedItem:[],
      upload:false,
      search:null,
      bredcrums:[],
      ResizePopup:false,
      imgWidth:null,

    }
  },
  computed: {
     allImages(){
       return this.images
    },
     allFolders(){
       return this.folders
    },
    activebredcrum(){
      let bredcrums = this.bredcrums
      if(bredcrums.length>0){
        let active = bredcrums[bredcrums.length -1].name
        bredcrums.pop();
        return active
      }
    },
     endLoding(){
      let ids = this.$store.getters.getCompleteResizeImg
                console.log(ids)

      if(ids && ids.length>0){
        let items = JSON.parse(localStorage.getItem('resize_imgs'))
        ids.forEach(id => {
         this.$vs.loading.close(`#div-with-${id} > .con-vs-loading`)
         let index = items.imgs.indexOf(id);
          if (index !== -1) {
             items.imgs.splice(index, 1); 
             localStorage.setItem('resize_imgs', JSON.stringify(items))
          }
      });
      this.SelectedItem=[] 
      this.get()
      }
    },
    setDisable(){ 
        if(this.imgWidth && this.SelectedItem.length>0){
                return false
            }
            else{
               return true
            }
        }
  },
 watch: {
    search: function (val) {
       if(val){
        this.images = this.orignal_images.filter(img => {
        return img.name.toLowerCase().includes(val.toLowerCase())
        })
        this.folders = this.orignal_folders.filter(folder => {
        return folder.name.toLowerCase().includes(val.toLowerCase())
        })
      }
      else{
        this.images=this.orignal_images
        this.folders=this.orignal_folders
      }
    },
    },
  methods: {
       addNewFolder (data) {
      this.folderSidebarData = data
      this.toggleFolderSidebar(true)
    },
    toggleFolderSidebar (val = false) {
      this.addNewFolderSidebar = val
    }, 
   SelectALL(){
     for (let index = 0; index < this.images.length; index++) {
       this.images[index].check=true
       this.SelectedItem.push(this.images[index].id)
     }
    },
    UnSelectALL(){
      this.SelectedItem=[]
      for (let index = 0; index < this.images.length; index++) {
       this.images[index].check=false
     }
    },  
        selectItem(id){
       let status = false
        for (let i = 0; i < this.SelectedItem.length; i++) {
          if (this.SelectedItem[i] === id) {
            this.SelectedItem.splice(i, 1)
            status = true
          }
        }
        if (!status) {
          this.SelectedItem.push(id)
        }
    },
       deleteImgAction(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete"`,
        accept: this.sureDeleteData,
        acceptText: 'Delete'
      })
    },
    sureDeleteData(){    
        this.$apollo
        .mutate({
          mutation: BULK_DELETE_IMAGES,
          variables: {
                id: this.SelectedItem,
          }
        })
        .then(response => {
          console.log(response);
            if(response.data.bulkDeleteImges.status==='Success'){
                this.$vs.notify({
                  title: 'Images',
                  text: 'Deleted successfully',
                  color: 'success',
                  position: 'top-right'
                })
               this.SelectedItem=[] 
                 this.get()
             }
                })
    }, 
  loader () {
  this.activeLoading = true
  this.$vs.loading({
  type:'sound'
  })
}, 
    sortByName(type){
    this.sortNameIcon=!this.sortNameIcon
    if(type==='desc'){
          this.images.sort(function (a, b) {
          const textA = a.name.toUpperCase()
          const textB = b.name.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
    }
    else{    
          this.images.sort(function (a, b) {
          const textA = a.name.toUpperCase()
          const textB = b.name.toUpperCase()
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0
        })
    }
  },
    sortByTime(type){
    this.sortTimeIcon=!this.sortTimeIcon
    if(type==='desc'){
          this.images.sort(function (a, b) {
          const textA = a.created_at
          const textB = b.created_at
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
    }
    else{    
          this.images.sort(function (a, b) {
          const textA = a.created_at
          const textB = b.created_at
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0
        })
    }
  },  
  deleteImg(value){
     for (let i = 0; i < this.images.length; i++) { 
        if (this.images[i].id == value) { 
          this.images.splice(i, 1) 
        }
      }
  },
  getdata (value) {
      if (value==='folder') {
        this.getFolder()
      }
      if(value==='image'){
        this.get()
      }
  }, 
    SaveFile (response, orignal_name) {

      if (response) {
        var key = response.key
        var location = response.location
        this.$apollo
        .mutate({
          mutation: ADD_IMAGE_TO_LIBRARY,
          variables: {
                name: orignal_name,
                key: key,
                url: location,
                folder:this.$route.params.folder
          }
        })
        .then(response => {
         if(response.data.addImageToLibrary.status==='Success'){
           this.get()
              //  this.images.unshift({
              //    'id':response.data.addImageToLibrary.color,
              //    'name':orignal_name,
              //     'key':key,
              //     'url':location,
              //     'check':false,
              //     'folder':this.$route.params.folder,
              //     'created_at':response.data.addImageToLibrary.message
              //  });
             }
          this.activeLoading = false
          this.$vs.loading.close()     
        }
        )

      }
    //   console.log(this.uplodedfiles)

    },
    uploadNewImage () {
      this.loader()
      for (let i = 0; i < this.$refs.uploadImageInput.files.length; i++) {
          const file = this.$refs.uploadImageInput.files[i]
          const orignal_name = this.$refs.uploadImageInput.files[i].name
          const name = Math.random().toString().slice(2)
        //   this.openLoadingInDiv()
          S3Client
            .uploadFile(file, name)
            .then(response => {
                console.log(response)
            //   this.$vs.loading.close('#div-with > .con-vs-loading')
              this.SaveFile(response, orignal_name)
            })
            .catch(err => console.error(err))
      }

    },
    get(){
        this.$apollo
        .mutate({
          mutation: GET_FOLDER_IMAGE,
          variables: {
                id: this.$route.params.folder
          }
        })
        .then(response => {
             this.images=response.data.getFolderImages
              for (let index = 0; index < this.images.length; index++) {
              this.images[index].check=false;
            }
            this.orignal_images=this.images
             if(localStorage.getItem('resize_imgs')){
            let data = JSON.parse(localStorage.getItem('resize_imgs'))
          if(data.imgs && data.imgs.length>0 && data.width){
                    setTimeout( ()=> {
              this.resizeAction(data.width,data.imgs)

            }, 5000);
     }
    }
        }
        )
    },
     getFolder(){
        this.$apollo
        .mutate({
          mutation: GET_FOLDER_SUBFOLDER,
          variables: {
                id: this.$route.params.folder
          }
        })
        .then(response => {
             this.folders=response.data.getFolderSubfolder
            this.orignal_folders=this.folders
        }
        )
    },
    getBredcrum(){
        this.$apollo
        .mutate({
          mutation: GET_DIRECTORY_BREDCRUM,
          variables: {
                id: this.$route.params.folder
          }
        })
        .then(response => {
             this.bredcrums=response.data.getDirectoryBredcrum
        }
        )
    },
        resizeAction(width,imgs){
      this.ResizePopup=false
      localStorage.setItem('resize_imgs',JSON.stringify({'imgs':imgs,'width':width}))
      imgs.forEach(element => {
        console.log(element)
        this.$vs.loading({
        container: `#div-with-${element}`,
        scale: 0.6,
        type:'material'
      })
      });
      this.$store.dispatch('setResizeImgs', {'width':width,'imgs':imgs})
    },
  },
  created () {
    this.getBredcrum()
    this.getFolder()
    this.get()
  }
}

</script>


<style lang="scss">
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {

    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: .5rem;
    }

    .vs-sidebar--items {
      border-radius: .5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}

</style>

